<template>
  <div class="news-wrap">
    <img src="../assets/news/news_bg.png" class="news-bg" alt="" />
    <div class="news-content">
      <div class="news-header">
        <div class="news-title">新闻动态</div>
        <div class="news-en-title">ABOUT US</div>
        <div class="news-under-line"></div>
      </div>
      <div style="display: flex">
        <div class="news-type">
          <div
            :class="{ 'item-tab': true, 'item-tab-active': val === '1' }"
            @click="changeTab('1')"
          >
            公司新闻
          </div>
          <div
            :class="{ 'item-tab': true, 'item-tab-active': val === '3' }"
            @click="changeTab('3')"
          >
            图片快讯
          </div>
        </div>
        <div class="news-list">
          <div
            class="item-news"
            v-for="(item, index) in list"
            :key="index"
            @click="getNewsDetail(item)"
          >
            <div class="item-news-left">
              <img
                :src="
                  item.noticeType == '3' ? baseUrl + item.cover : item.cover
                "
                alt=""
                style="width: 272px"
              />
              <div style="margin-left: 54px">
                <div class="right-title">
                  {{ item.noticeTitle }}
                </div>
                <div class="right-info">
                  {{ item.intro }}
                </div>
              </div>
            </div>
            <div class="item-news-right">
              {{ item.releaseTime.split("-")[0] }}-{{
                item.releaseTime.split(" ")[0].split("-")[1]
              }}-{{ item.releaseTime.split(" ")[0].split("-")[2] }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "News",
  data() {
    return {
      query: {
        pageNum: 1,
      },
      list: [],
      val: "1",
      baseUrl: process.env.VUE_APP_BASE_API,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    changeTab(val) {
      this.val = val;
      this.getList();
    },
    getList() {
      fetch(
        `/prod-api/system/notice/pageList?pageNum=${this.query.pageNum}&pageSize=5&noticeType=${this.val}`,
        {
          method: "get",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          this.list = res.rows;
        });
    },
    getNewsDetail(info) {
      this.$router.push({
        path: "/newsDetail",
        query: { id: info.noticeId, noticeType: info.noticeType },
      });
    },
  },
};
</script>
<style scoped lang="less">
.news-wrap {
  .news-bg {
    width: 100%;
  }
  .news-content {
    width: 1200px;
    margin: 0 auto;
    padding-top: 60px;
    .news-header {
      padding-bottom: 30px;
      margin-bottom: 30px;
      border-bottom: 1px solid #dededc;
      .news-title {
        text-align: center;
        color: #333333;
        font-weight: 400;
        font-size: 32px;
      }
      .news-en-title {
        text-align: center;
        color: #153578;
        font-size: 26px;
        font-weight: 300;
        margin-top: 14px;
      }
      .news-under-line {
        background: #153578;
        width: 30px;
        height: 3px;
        margin: 15px auto 0;
      }
    }
  }
}
.news-type {
  width: 240px;
  padding-left: 20px;
  padding-top: 10px;
  .item-tab {
    width: 136px;
    height: 40px;
    background: #fff;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000;
    user-select: none;
    cursor: pointer;
    font-size: 18px;
    margin-bottom: 10px;
  }
  .item-tab-active {
    background: #1a8bd2;
    color: #fff;
  }
}
.news-list {
  width: 960px;
  min-height: 820px;
  .item-news {
    height: auto;
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #dededc;
    padding: 20px 0;
    .item-news-left {
      width: 1000px;
      display: flex;
      padding-right: 20px;
      .right-title {
        color: #333333;
        font-size: 16px;
        font-weight: 400;
      }
      .right-info {
        color: #666666;
        font-weight: 400;
        font-size: 14px;
        margin-top: 30px;
      }
    }
    .item-news-right {
      width: 150px;
      height: 100%;
      text-align: right;
      color: #333333;
      font-size: 16px;
      font-weight: 400;
    }
  }
}
</style>
